"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var QuoteAlternate = function QuoteAlternate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 35 45"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "20",
    strokeWidth: "2",
    d: "M.98 5.81a2 2 0 0 1 2-2h29.047a2 2 0 0 1 2 2v36.078a2 2 0 0 1-2 2H2.98a2 2 0 0 1-2-2z"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 15.766h9.14a.703.703 0 1 0 0-1.406h-9.14a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 37.566h9.14a.703.703 0 1 0 0-1.406h-9.14a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 19.986h20.39a.703.703 0 1 0 0-1.406H7.304a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 28.426h20.39a.703.703 0 1 0 0-1.406H7.304a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 33.346h20.39a.703.703 0 1 0 0-1.406H7.304a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M7.303 24.206h9.844a.703.703 0 1 0 0-1.406H7.303a.703.703 0 1 0 0 1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M27.695 22.8h-4.922a.703.703 0 1 0 0 1.406h4.922a.703.703 0 1 0 0-1.406z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M19.464 22.998a.693.693 0 0 0-.204.499.736.736 0 0 0 .204.5.696.696 0 0 0 .5.203.696.696 0 0 0 .702-.703.697.697 0 0 0-.204-.5.73.73 0 0 0-.998 0z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M5.2 5.41a3 3 0 0 1 3-3h18.61a3 3 0 0 1 3 3v.328a3 3 0 0 1-3 3H8.2a3 3 0 0 1-3-3z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "20",
    strokeWidth: "2",
    d: "M5.9 5.11a2 2 0 0 1 2-2h19.203a2 2 0 0 1 2 2v.922a2 2 0 0 1-2 2H7.9a2 2 0 0 1-2-2z"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ffffff",
    d: "M11.52 3a2 2 0 0 1 2-2h8.656a2 2 0 0 1 2 2v.922a2 2 0 0 1-2 2H13.52a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "20",
    strokeWidth: "2",
    d: "M12.23 2.7a1 1 0 0 1 1-1h9.25a1 1 0 0 1 1 1v1.516a1 1 0 0 1-1 1h-9.25a1 1 0 0 1-1-1z"
  }))))))));
};
var _default = exports.default = QuoteAlternate;